import { render, staticRenderFns } from "./ProjetoExtrato.vue?vue&type=template&id=1f8b61c8&"
import script from "./ProjetoExtrato.vue?vue&type=script&lang=js&"
export * from "./ProjetoExtrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports